export var communityConfiguration = {
  digestDeliveryOptions: [{
    value: 'default',
    label: 'Default'
  }, {
    value: 'weekdays',
    label: 'Weekdays'
  }, {
    value: 'daily',
    label: 'Monday, Tuesday...'
  }]
};